import { EnglishArabicDTO } from "bnsights-control-library"
export class DepartmentModel
{
  Id: number
  SectorId?: number
  IDEncrypted: string
  DepartmentNameDTO: EnglishArabicDTO = new EnglishArabicDTO();
  DepartmentName: string;
  SectorName: string;
  UsersCount: number
  SamAccount: string
}
